import styled from '@emotion/styled';

const Blog:React.FC<any> = () => {
  const handleFirstBlog = () => {
    window.open("https://blog.naver.com/parkhana5819/223463317908", "_blank")
  };

  const handleSecondBlog = () => {
    window.open("https://m.blog.naver.com/PostView.naver?blogId=codmswl0098&logNo=223464486755&proxyReferer=https:%2F%2Fwww.photypeta.com%2F&trackingCode=external", "_blank")
  }

  return (
    <Container>
        <Title>
          1년 구독자의 솔직한 후기
        </Title>
      {/* <StarContainer>
        <StarImg src="/images/newLanding/home/heartStar2.png"/>
      </StarContainer> */}
      <CardContainer>
        <Card
          onClick={handleFirstBlog}
        >
          <Img src="/images/newLanding/home/blog1.png"/>
        </Card>
        <Card
          onClick={handleSecondBlog}
        >
          <Img src="/images/newLanding/home/blog2.png"/>
        </Card>
        {/* <Card>
          <TextContainer>
          이엘이가 커서 "나는 어릴 때 이랬구나 ~" 하며
          <br/>볼 수 있는 앨범이 있었으면 좋겠다는 생각에
          <br/> 벌써 1년 넘게 구독 중인 포티페타
          </TextContainer>
          <br/>_my__yuju
        </Card>
        <Card>
          <TextContainer>
            울 강아지 태어난 순간부터 차곡 차곡 쌓여가는 예쁘고 사랑스러운 모습들🤍          
            <br/> 매달 인화 알람이 오니 편하다 헤헤 한달도 거르지 않고 7개 월째 구독중
            <br/> 시중에 있는 앨범 패키지 중에 제일 예뻐
          </TextContainer>
          <br/>juyul_luvhouse
        </Card>
        <Card>
          <TextContainer>
          포토앨범에 일기에 나름 꽤 많이 만들어 봤지만
          <br/> 결국엔 꼭 밀리고 나중엔 쌓여가는 사진 고르다가 포기
          <br/>포토 프린터를 두 개나 가지고 있어도 안뽑게 되는 현실에
          <br/>이런 서비스 너무 좋아....
          </TextContainer>
          <br/>lulu_jyh
        </Card> */}
      </CardContainer>
    </Container>
  )
};

export default Blog;

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const Title = styled.h2`
  font-size: 24px;
  font-weight: 600;
  /* margin: 80px auto 10px; */
  margin: 80px auto 40px;
  text-align: center;
  display: flex;
  flex-direction: column;
  line-height: 1.2;
`;
// const TopTextContaienr = styled.div`
//   margin: 50px auto 5px;
//   display: flex;
//   flex-direction: row;  
//   font-size: 14px;
//   align-items: center;
//   color: #6e6e6e;

//   span {
//     &.background {
//       background-color: #6e6e6e;
//       color: white;
//     }

//     &.size {
//       font-size: 24px;
//     }

//     &.percent {
//       position: relative;
//       font-size: 14px;
//       top: 4px; 
//     }
//   }
// `

const Card = styled.div`
  width: 100%;
  height: 90%;
  margin: 0 auto 30px;

  &.third {
    padding: 0 25px;
  }
`;

// const Card = styled.div`
//   width: 90%;
//   min-height: 150px;
//   margin: 0 auto;
//   background-color: lightblue;
// `

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
`

const Img = styled.img`
  width: 100%;
  height: 100%;
`
const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 60px;
  /* height: 80%; */
  justify-content: space-between;
`
const StarContainer = styled.div`
  width: 50%;
  margin: 0 auto 50px;
`;

const StarImg = styled.img`
  /* height: 100%; */
  width: 100%;
`